import React from "react";

export default function Achievement() {
  return (
    <div className="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
        <div className="container">
         <h2 className="mt-5 text-center">Achievement 🏆</h2>
      <hr className="w-25 mx-auto" />
        <div>
         <p className="shadow p-3 mb-5 bg-body-tertiary rounded">⭐ Awarded the ”Best Performer Medal” for outstanding performance during
          the summer training program.</p> 
         <p className="shadow p-3 mb-5 bg-body-tertiary rounded">⭐ Contributed to open-source projects in Hacktoberfest, and earned
          Hacktoberfest T-shirt and received recognition for impactful
          open-source contributions.</p>  
         </div>
      </div>

    </div>
  );
}
